import { selectWarehouse } from 'containers/Warehouses/warehousesSlice'
import DateTile from 'containers/OrderDetails/Calendar/DateTile'
import { useHistory, useParams } from 'react-router-dom'
import ArrowBtn from 'components/buttons/ArrowBtn'
import useTranslation from 'hooks/useTranslation'
import InvoicesSection from './InvoicesSection'
import { useReduxSelector } from 'store'
import { toLongDate } from 'utils/date'
import { forwardRef } from 'react'
import { SECTION_TYPES } from '..'

const MagDetails = forwardRef<HTMLDivElement>((_, ref) => {

  const { id } = useParams<warehouse.PageParams>()
  const { typeName, fullDateFrom, fullDateTo, size, placeName, placeAddress, clientName, clientSurname, clientAddress, isShared, permissions, terminationTerms, resignation } = useReduxSelector(state => selectWarehouse(state, id))

  const { push } = useHistory()
  const { t, lang } = useTranslation('warehouse')
  const openAction = (action: keyof typeof SECTION_TYPES) => {
    push(`/warehouses/${id}/${action}`)
  }

  return (
    <div className='menu__section summary'>
      <p>{t('rentalDetails')}</p>

      <div
        ref={ref}
        className='menu__details'>

        <div className='details__date calendar'>
          <div className='calendar__main'>
            <div className='calendar__inputs center'>
              <DateTile
                start
                date={fullDateFrom}
              />
              <DateTile
                date={resignation?.date || fullDateTo}
              />
            </div>
          </div>
        </div>

        <div className='list'>
          <div>
            <div className='list__header element__title'>{typeName}</div>
            <div className='list__element --big'>
              <div className='element__desc'>
                <div>{t('area')}: {Number(size?.area)}m²</div>
                <div>{t('length')}: {size?.internalLength}m</div>
                <div>{t('width')}: {size?.internalWidth}m</div>
                <div>{t('height')}: {size?.internalHeight}m</div>
              </div>
            </div>
          </div>
          <div>
            <div className='list__header element__title'>{t('location')}</div>
            <div className='list__element --big'>
              <div className='group'>
                <div className='element__desc'>
                  <div>{placeName}</div>
                  {placeAddress && placeAddress.split(', ').map((text, index) => <div key={index}>{text}</div>)}
                </div>
                <div
                  className='element__desc'
                  onClick={() => {
                    window.open(`https://www.google.com/maps/search/?api=1&query=${placeAddress}`)
                  }}>
                  {t('show')}
                </div>
              </div>
            </div>
          </div>
          <div>
            <div className='list__header element__title'>{t('tenant')}</div>
            <div className='list__element --big'>
              <div>
                <div
                  className='element__title'
                  style={{ marginBottom: '0.5em' }}>
                  {clientName} {clientSurname}
                </div>
                <div className='element__desc'>
                  {clientAddress && clientAddress.split(', ').map((text, index) => <div key={index}>{text}</div>)}
                </div>
              </div>
            </div>
          </div>
          {(!isShared || permissions?.includes('contract')) && resignation && <div>
            <div className='list__header element__title'>{t(`resignationType.${resignation.type}`)}</div>
            <div className='list__element --big'>
              <div className='group'>
                <div className='element__desc'>
                  <div>{t('endDate')}: {toLongDate(resignation.date, lang, true)}</div>
                  {resignation.reason && <div>{t('reason')}: {resignation.reason}</div>}
                  <div>{t('attachments')}: {resignation.documents.length > 0 ? resignation.documents.length === 1 ? t('onePhoto') : `${resignation.documents.length} ${t('photos')}` : t('none')}</div>
                </div>
                <div
                  className='element__desc'
                  onClick={() => {
                    openAction(resignation.type as keyof typeof SECTION_TYPES)
                  }}>
                  {t('edit')}
                </div>
              </div>
            </div>
          </div>}
          {(!isShared || permissions?.includes('invoice')) && <InvoicesSection />}
        </div>

        {(!isShared || permissions?.includes('contract'))
          ? <div className='details__buttons'>
            {((resignation?.type === 'termination' && resignation?.date) || fullDateTo) && <ArrowBtn
              enlarged
              text={t('extendYourRental')}
              action={() => {
                openAction('extension')
              }}
            />}
            {!resignation && <ArrowBtn
              enlarged
              text={t('terminateRental')}
              action={() => {
                openAction('termination')
              }}
            />}
            {(terminationTerms?.canCancel && !resignation) && <div
              className='button__cancel'
              onClick={() => {
                openAction('cancel')
              }}>
              {t('cancelRental')}
            </div>}
          </div>
          : <div className='details__buttons' />}
      </div>
    </div>
  )
})

export default MagDetails